import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MountainLake4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MOUNTAIN_LAKE4;
}

export default MountainLake4PoiTileEntity;
